import {
  reactQueryGet,
  reactQueryPatch,
  reactQueryPost,
} from "../helpers/backendRequestHelpers";
import { internalApi } from "../helpers/urlHelpers";
import type { SenderAddress } from "./emailHub/senderAddressesApi.interfaces";

export interface NewsletterHomepage {
  is_published: boolean;
  page_id: number;
}

export interface Newsletter {
  community_id: number;
  created_at: string;
  email_hub_sender_address?: SenderAddress;
  email_hub_sender_address_id: number | null;
  homepage: NewsletterHomepage | null;
  id: number;
  name: string;
  updated_at: string;
  web_url: string;
}

export interface NewsletterSlugConflict {
  page_id: number;
  page_name: string;
}

export interface NewsletterActivationCheck {
  slug_conflict: NewsletterSlugConflict | null;
}

export interface CreateNewsletterParams {
  email_hub_sender_address_id?: number;
  name: string;
}

export interface UpdateNewsletterParams {
  email_hub_sender_address_id?: number | null;
  name?: string;
}

const list = (): Promise<Newsletter[]> =>
  reactQueryGet<Newsletter[]>(internalApi.newsletters.list());

const activationCheck = (): Promise<NewsletterActivationCheck> =>
  reactQueryGet<NewsletterActivationCheck>(
    internalApi.newsletters.activationCheck(),
  );

const create = (body: CreateNewsletterParams): Promise<Newsletter> =>
  reactQueryPost<Newsletter, { newsletter: CreateNewsletterParams }>(
    internalApi.newsletters.create(),
    { newsletter: body },
  );

const update = ({
  id,
  body,
}: {
  body: UpdateNewsletterParams;
  id: number;
}): Promise<Newsletter> =>
  reactQueryPatch<Newsletter, { newsletter: UpdateNewsletterParams }>(
    internalApi.newsletters.update({ id }),
    { newsletter: body },
  );

export const newslettersApi = {
  activationCheck,
  create,
  list,
  update,
};
